import { createAction, props } from '@ngrx/store';

export const setPaginationData = createAction(
  '[Pagination] Set Pagination Data',
  props<{ pageNumber: number; pageSize: number }>()
);
